import { render, staticRenderFns } from "./VArticle.vue?vue&type=template&id=707855b9&"
import script from "./VArticle.vue?vue&type=script&lang=js&"
export * from "./VArticle.vue?vue&type=script&lang=js&"
import style0 from "./VArticle.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports